type Props = {
	title?: string;
	description?: React.ReactNode;
	children: React.ReactNode;
}
export const SummaryCard: React.FunctionComponent<Props> = ({
	title,
	description,
	children,
}) => {
	return (
		<section className="summary-card">
			{(title || description) && (
				<header>
					{title && <h3>{title}</h3>}
					{description && <>{description}</> }
				</header>
			)}
			<div>
				{children}
			</div>
		</section>
	)
}